var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1864",
    "data-name": "Rectangle 1864",
    width: 18,
    height: 18,
    transform: "translate(0.097 0.097)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9147",
    "data-name": "Group 9147",
    transform: "translate(23.903 -0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5297",
    "data-name": "Group 5297",
    transform: "translate(-24 0.003)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14509",
    "data-name": "Path 14509",
    d: "M17.94,6.26,11.117.195A.748.748,0,0,0,10.3.067.757.757,0,0,0,9.855.76V3.192C7.578,3.8,0,6.648,0,17.439a.759.759,0,0,0,1.463.281c2.248-5.621,6.627-6.793,8.392-7.036V12.89a.756.756,0,0,0,1.262.566L17.94,7.391a.755.755,0,0,0,0-1.131",
    transform: "translate(0 -0.002)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon1);
export default __webpack_public_path__ + "static/media/share-icon1.740da3336822a897676ad896cef132d9.svg";
export { ForwardRef as ReactComponent };